/**
 * Path prefixes that should be treated as private (authenticated app surfaces)
 * by the auth-change-listener on team subdomains. Includes the default
 * subdomain-rewrite targets (e.g. /home, /admin) AND the top-level paths the
 * browser actually sees on team subdomains after the rewrite (e.g. /vault,
 * /planning), since sounders.arkero.ai/vault rewrites server-side to
 * /home/sounders/vault but the client still sees /vault.
 *
 * Without these, SIGNED_OUT calls window.location.reload() on real
 * authenticated team-subdomain surfaces.
 */
export const TEAM_SUBDOMAIN_PRIVATE_PREFIXES = [
  '/home',
  '/admin',
  '/join',
  '/identities',
  '/update-password',
  '/vault',
  '/planning',
  '/events',
  '/meetings',
  '/documents',
  '/blueprints',
  '/integrations',
  '/settings',
  '/agents',
  // Legacy Agents path; redirects to /agents but stays private until it does.
  '/playbooks',
  '/workspaces',
  '/tasks',
  '/billing',
  '/meeting-assistant',
];
